"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.titlecase = void 0;

var titlecase = function titlecase(string) {
  return string.replace(/(?:^|\s|-)\S/g, function (a) {
    return a.toUpperCase();
  });
};

exports.titlecase = titlecase;


//////////////////
// WEBPACK FOOTER
// ./js/utils/strings.js
// module id = 444
// module chunks = 209 210 211 212